export default __webpack_public_path__ + "img/855834b63e7e4a9db17663b2b4f83b4c.svg";